<template>
	<svg :width="width" :height="height" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
		<g>
			<path
				d="
					M15 7V21M18 11H18.01M18 14H18.01M18 17H18.01M17 3L12 7L7 3M7.8 21H16.2C17.8802 21 18.7202 21 19.362
					20.673C19.9265 20.3854 20.3854 19.9265 20.673 19.362C21 18.7202 21 17.8802 21 16.2V11.8C21 10.1198 21
					9.27976 20.673 8.63803C20.3854 8.07354 19.9265 7.6146 19.362 7.32698C18.7202 7 17.8802 7 16.2 7H7.8C6.11984
					7 5.27976 7 4.63803 7.32698C4.07354 7.6146 3.6146 8.07354 3.32698 8.63803C3 9.27976 3 10.1198 3 11.8V16.2C3
					17.8802 3 18.7202 3.32698 19.362C3.6146 19.9265 4.07354 20.3854 4.63803 20.673C5.27976 21 6.11984 21 7.8 21Z
				"
				:stroke="color" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
			></path>
		</g>
	</svg>
</template>

<script>
export default {
	name: 'TvIcon',
	props: {
		width: {
			type: Number,
			default: 32,
		},
		height: {
			type: Number,
			default: 32,
		},
		color: {
			type: String,
			default: 'black',
		},
	},
}
</script>
